import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CoreResearchEntities } from 'client/data/models/core-research';
import { getS3MediaProfileImageUrlBySize } from 'client/utils/image-helpers';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { generateSrpLinkMakeModel } from 'site-modules/shared/utils/srp-link-constructor';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { Link } from 'site-modules/shared/components/link/link';
import { RatingStarsCount } from 'site-modules/shared/components/rating-stars-count/rating-stars-count';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

const IMAGE_WIDTH = 300;
const IMAGE_HEIGHT = 200;

export function AlsoViewedVehicleCardCrossShop({ vehicle = null, lazyLoadImage = false, isUsed = false }) {
  if (!vehicle) {
    return null;
  }

  const {
    make: { name: makeName, slug: makeSlug },
    model: { name: modelName, slug: modelSlug },
    year,
    startPrice,
    consumerRating,
  } = vehicle;

  return (
    <div className="vehicle-card bg-gray-extra-light rounded me-1">
      <Link
        className="d-block"
        to={getCoreUrl({ makeSlug, modelSlug, year })}
        data-tracking-id="mmy_select_submit"
        data-tracking-value={`${makeName} ${modelName}`}
      >
        <AspectRatioContainer aspectRatio="3:2">
          <img
            className="w-100"
            src={getS3MediaProfileImageUrlBySize(vehicle, IMAGE_WIDTH, IMAGE_HEIGHT)}
            alt=""
            loading={lazyLoadImage ? 'lazy' : undefined}
          />
        </AspectRatioContainer>
        <div className={classnames('vehicle-card-info pos-r pt-1 px-0_75', { 'used-vehicle': isUsed })}>
          <div className="text-primary-darker">
            {makeName} {modelName}
          </div>
          {consumerRating && (
            <RatingStarsCount
              starsColor="primary-darker"
              starsWrapperClass="no-ml medium"
              ratingAverage={consumerRating.averageRating}
              ratingCount={consumerRating.reviewsCount}
              ratingCountClass="ms-0_5 text-gray-dark small"
            />
          )}
          {startPrice && (
            <div
              className={classnames('pricing w-100', {
                'pb-0_5': isUsed,
                'pb-3': !isUsed,
              })}
            >
              <span className="me-0_25">Starting at</span>
              <span>{formatPriceString(startPrice)}</span>
            </div>
          )}
        </div>
      </Link>
      {isUsed && (
        <Link
          className="inventory-cta d-block w-100 text-primary-darker p-0_5 px-0_75"
          to={generateSrpLinkMakeModel(makeSlug, modelSlug)}
        >
          See
          <span className="visually-hidden">
            &nbsp;{makeName} {modelName}
          </span>{' '}
          Inventory
        </Link>
      )}
    </div>
  );
}

AlsoViewedVehicleCardCrossShop.propTypes = {
  vehicle: CoreResearchEntities.SimilarVehicleCrossShop,
  lazyLoadImage: PropTypes.bool,
  isUsed: PropTypes.bool,
};
